import React from 'react';

export type TimeFilterOption = '30D' | '60D' | '90D' | '180D' | '1Y' | '2Y' | '5Y' | 'MAX';

interface TimeFilterProps {
  selectedFilter: TimeFilterOption;
  onFilterChange: (filter: TimeFilterOption) => void;
  className?: string;
}

const TimeFilter: React.FC<TimeFilterProps> = ({ selectedFilter, onFilterChange, className = '' }) => {
  const filterOptions: { value: TimeFilterOption; label: string }[] = [
    { value: '30D', label: '30D' },
    { value: '60D', label: '60D' },
    { value: '90D', label: '90D' },
    { value: '180D', label: '180D' },
    { value: '1Y', label: '1Y' },
    { value: '2Y', label: '2Y' },
    { value: '5Y', label: '5Y' },
    { value: 'MAX', label: 'MAX' },
  ];

  return (
    <div className={`flex flex-wrap gap-2 ${className}`}>
      {filterOptions.map((option) => (
        <button
          key={option.value}
          onClick={() => onFilterChange(option.value)}
          className={`px-3 py-1 text-sm font-medium rounded-md transition-colors ${
            selectedFilter === option.value
              ? 'bg-primary-600 text-white'
              : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
          }`}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
};

export default TimeFilter;
